<template>
  <div class="content--sinoreg ImportarImagensEmLote p-1">
    <header-blue>
      <h4>Importar imagens em lote</h4>
    </header-blue>

    <router-view />
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from '@/components/SofiaRei/Headers/HeaderBlue'

  export default {
    name: 'ImportarImagensEmLote',
    components: {
      HeaderBlue
    }
  }
</script>

<style lang="scss" scoped>
  .ImportarImagensEmLote {
    &_table {
      &--header {
        background-color: #01bfa5;
      }
      &--row {
        cursor: pointer;
      }
    }
  }
</style>
